import { Autocomplete, Box, Dialog, IconButton, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AXIS_OPTIONS, COMMON_STYLE, CYL_OPTIONS, SPH_OPTIONS } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CloseIcon from '@mui/icons-material/Close';

const UmaAutoRefractory = React.forwardRef((props, ref) => {
    const [autoRef, setAutoRef] = useState({
        patient_details: {},
        clinic_id: '',
        appointment_id: '',
        patient_id: '',
        autoRefDataBefore: [],
        autoRefDataAfter: [],
        SPHList: SPH_OPTIONS,
        CYLList: CYL_OPTIONS,
        AXISList: AXIS_OPTIONS,
        autoRefComments: '',
        loadScreen: false,
        prevAutoRefComments: '',
        prevAutoRefDataAfter: [],
        prevAutoRefDataBefore: [],
        enableAftCopy: false,
        enableBfrCompare: false,
        enableBfrCopy: false,
        enableAftCompare: false,
        openAftComparePopup: false,
        openBfrComparePopup: false,
        dupAutoRefDataAfter: '[]',
        dupAutoRefDataBefore: '[]',
        dupAutoRefComments: ''
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - AUTO REFRACTOMENTRY`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - AUTO REFRACTOMENTRY`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    React.useImperativeHandle(ref, () => ({
        performAutoRefractoryAction: () => {
            if (
                (JSON.stringify(autoRef.autoRefDataBefore) !== autoRef.dupAutoRefDataBefore) ||
                (JSON.stringify(autoRef.autoRefDataAfter) !== autoRef.dupAutoRefDataAfter) ||
                JSON.stringify(autoRef.autoRefComments) !== autoRef.dupAutoRefComments
            ) {
                postAutoRefraData()
            }
        }
    }))

    const apicalls = async () => {
        await getAutoRefractoData()
        await getPrevAutoRefractionData()
    }

    useEffect(() => {
        if (autoRef.autoRefDataAfter && autoRef.autoRefDataBefore && autoRef.prevAutoRefDataAfter && autoRef.prevAutoRefDataBefore) {
            let bfrCopy = autoRef.prevAutoRefDataBefore?.length > 0 ? autoRef.prevAutoRefDataBefore?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let aftrCopy = autoRef.prevAutoRefDataAfter?.length > 0 ? autoRef.prevAutoRefDataAfter?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let bfrCompare = autoRef.autoRefDataBefore?.length > 0 ? autoRef.autoRefDataBefore?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            let aftrCompare = autoRef.autoRefDataAfter?.length > 0 ? autoRef.autoRefDataAfter?.some((item) => (item?.SPH !== '' || item?.CYL !== '' || item?.AXIS)) : false
            setAutoRef((prev) => ({
                ...prev,
                enableAftCompare: aftrCompare,
                enableBfrCompare: bfrCompare,
                enableAftCopy: aftrCopy,
                enableBfrCopy: bfrCopy
            }))
        }
    }, [autoRef.autoRefDataAfter, autoRef.autoRefDataBefore, autoRef.prevAutoRefDataAfter, autoRef.prevAutoRefDataBefore])

    const getAutoRefractoData = async () => {
        try {
            let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_AUTO_REFRACTOMENTRY + '?appointment_id=' + props.props.appointment_id + '&doctor_id=' + props?.props?.doctorID)
            if (response?.data?.status === 'success') {
                let autoBefore = [
                    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "" },
                    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "" },
                ]
                let autoAfter = [
                    { "eye_type": "RE", "SPH": "", "CYL": "", "AXIS": "" },
                    { "eye_type": "LE", "SPH": "", "CYL": "", "AXIS": "" },
                ]
                let autoRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                setAutoRef((prev) => ({
                    ...prev,
                    autoRefDataAfter: Object.keys(autoRef)?.length > 0 ? autoRef?.after_dilation : autoAfter,
                    autoRefDataBefore: Object.keys(autoRef)?.length > 0 ? autoRef?.before_dilation : autoBefore,
                    autoRefComments: Object.keys(autoRef)?.length > 0 ? autoRef?.comments : '',
                    dupAutoRefDataAfter: Object.keys(autoRef)?.length > 0 ? JSON.stringify(autoRef?.after_dilation) : JSON.stringify(autoAfter),
                    dupAutoRefDataBefore: Object.keys(autoRef)?.length > 0 ? JSON.stringify(autoRef?.before_dilation) : JSON.stringify(autoBefore),
                    dupAutoRefComments: Object.keys(autoRef)?.length > 0 ? JSON.stringify(autoRef?.comments) : JSON.stringify(''),
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const getPrevAutoRefractionData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_AUTO_REFRACTOMENTRY_COPY +
                '?appointment_id=' + props.props.appointment_id + '&patient_id=' + props.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
            )
            if (response?.data?.status === 'success') {
                let autoRef = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
                setAutoRef((prev) => ({
                    ...prev,
                    prevAutoRefDataAfter: Object.keys(autoRef)?.length > 0 ? autoRef?.after_dilation : [],
                    prevAutoRefDataBefore: Object.keys(autoRef)?.length > 0 ? autoRef?.before_dilation : [],
                    prevAutoRefComments: Object.keys(autoRef)?.length > 0 ? autoRef?.comments : '',
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const postAutoRefraData = async () => {
        try {
            let data = {
                appointment_id: props.props?.appointment_id,
                comments: autoRef.autoRefComments,
                before_dilation: autoRef.autoRefDataBefore,
                after_dilation: autoRef.autoRefDataAfter
            }
            const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_AUTO_REFRACTOMENTRY)
            if (response?.data?.status === 'success') {
                successMessage(response?.data?.message)
                await getAutoRefractoData()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error?.response?.data?.message)
            } else {
                errorMessage(error?.message)
            }
        }
    }

    const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index, key) => {
        try {
            return (
                <Autocomplete
                    disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                    clearIcon
                    size='small'
                    sx={{ width: '10dvw' }}
                    value={values || ""}
                    options={options}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
                    onChange={(e, newValue) => {
                        if (key === 'Before') {
                            let autoRefDataBefore = [...autoRef.autoRefDataBefore]
                            autoRefDataBefore[index] = { ...autoRefDataBefore[index], [names]: newValue ? newValue?.label || "" : "" }
                            setAutoRef((prev) => ({ ...prev, autoRefDataBefore: autoRefDataBefore }))
                        } else {
                            let autoRefDataAfter = [...autoRef.autoRefDataAfter]
                            autoRefDataAfter[index] = { ...autoRefDataAfter[index], [names]: newValue ? newValue?.label || "" : "" }
                            setAutoRef((prev) => ({ ...prev, autoRefDataAfter: autoRefDataAfter }))
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={placeholders}
                            InputProps={{
                                ...params.InputProps,
                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                            }}
                        />
                    )}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const beforeDilationTable = () => {
        try {
            return (
                <Box component={'div'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>Before Dilation</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} ml={'0.5rem'}>
                            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                                disabled={!autoRef.enableBfrCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                                onClick={() => setAutoRef((prev) => ({
                                    ...prev, openBfrComparePopup: false,
                                    autoRefDataBefore: autoRef.prevAutoRefDataBefore
                                }))}
                            ><ContentCopyIcon color={!autoRef?.enableBfrCopy ? '' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                                onClick={() => setAutoRef((prev) => ({ ...prev, openBfrComparePopup: true }))}
                                disabled={!(autoRef.enableBfrCopy && autoRef.enableBfrCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><VisibilityIcon color={!(autoRef.enableBfrCopy && autoRef.enableBfrCompare) ? '' : 'primary'} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {autoRef?.autoRefDataBefore?.length > 0 ? autoRef?.autoRefDataBefore?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, autoRef?.SPHList, 'label', 'SPH', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, autoRef?.CYLList, 'label', 'CYL', index, 'Before')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, autoRef?.AXISList, 'label', 'AXIS', index, 'Before')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell align='center' colSpan={4}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderBfrComparePopup = () => {
        try {
            return (
                <Dialog open={autoRef.openBfrComparePopup} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Compare Before Dilation Auto Refractometry</Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setAutoRef((prev) => ({ ...prev, openBfrComparePopup: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>Current Before Dilation</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setAutoRef((prev) => ({
                                                ...prev,
                                                autoRefDataBefore: autoRef.prevAutoRefDataBefore,
                                                openBfrComparePopup: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {autoRef.prevAutoRefDataBefore?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>New Before Dilation</Typography>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {autoRef.autoRefDataBefore?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const afterDilationScreen = () => {
        try {
            return (
                <Box component={'div'} mt={'0.5rem'}>
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>After Dilation</Typography>
                        <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5rem'}>
                            <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_cpy'
                                onClick={() => setAutoRef((prev) => ({
                                    ...prev,
                                    openAftComparePopup: false,
                                    autoRefDataAfter: autoRef.prevAutoRefDataAfter
                                }))}
                                disabled={!autoRef.enableAftCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><ContentCopyIcon color={!autoRef.enableAftCopy ? '' : 'primary'} /></IconButton></Tooltip>
                            <Tooltip placement='top' arrow title={'View'}><IconButton className='Common_Btn_Min_Width' emed_tid='rtno_vis'
                                onClick={() => setAutoRef((prev) => ({ ...prev, openAftComparePopup: true }))}
                                disabled={!(autoRef.enableAftCopy && autoRef.enableAftCompare) || props?.props?.patient_transfered || props?.props?.isLocked}
                            ><VisibilityIcon color={!(autoRef.enableAftCopy && autoRef.enableAftCompare) ? '' : 'primary'} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <Box component={'div'} border={'1px solid lightgray'} m={'0.5rem 0rem'}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                    <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {autoRef?.autoRefDataAfter?.length > 0 ? autoRef?.autoRefDataAfter?.map((item, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('SPH', item?.SPH, autoRef?.SPHList, 'label', 'SPH', index, 'After')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('CYL', item?.CYL, autoRef?.CYLList, 'label', 'CYL', index, 'After')}
                                            </TableCell>
                                            <TableCell className='doc_notes_tbl_body_cell'>
                                                {autocompleteTextBox('AXIS', item?.AXIS, autoRef?.AXISList, 'label', 'AXIS', index, 'After')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : <TableRow><TableCell colSpan={4} align='center'>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderAftComparePopup = () => {
        try {
            return (
                <Dialog open={autoRef.openAftComparePopup} maxWidth="md" fullWidth>
                    <Box className='doc_addendum_popup'>
                        <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography className='doc_notes_header_card_font'>Compare After Dilation Auto Refractometry</Typography>
                            <IconButton emed_tid='cmp_prev_cls'
                                onClick={() => setAutoRef((prev) => ({ ...prev, openAftComparePopup: false }))}><CloseIcon /></IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Box component={'div'} display={'flex'} alignItems={'center'}>
                                <Typography className='doc_notes_header_card_font'>Current After Dilation</Typography>
                                <Tooltip placement='top' arrow title={'Copy'}>
                                    <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                                        onClick={() => {
                                            setAutoRef((prev) => ({
                                                ...prev,
                                                autoRefDataAfter: autoRef.prevAutoRefDataAfter,
                                                openAftComparePopup: false
                                            }))
                                        }}
                                    ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
                            </Box>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {autoRef.prevAutoRefDataAfter?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography className='doc_notes_header_card_font'>New After Dilation</Typography>
                            <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                                            <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {autoRef.autoRefDataAfter?.map((item, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.eye_type}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.SPH}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.CYL}</TableCell>
                                                    <TableCell className='doc_notes_tbl_body_cell'>{item.AXIS}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Box>
                    </Box>
                </Dialog >
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apicalls}>
            <Box component={'div'}>
                <Box component={'div'}>
                    <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography className='doc_notes_header_card_font'>Auto Refractometry</Typography>
                    </Box>
                    <Box component={'div'} m={'0.5rem'}>
                        {beforeDilationTable()}
                        {afterDilationScreen()}
                        <Box component={'div'}>
                            <TextField
                                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                                size='small'
                                multiline
                                fullWidth
                                maxRows={5}
                                value={autoRef.autoRefComments}
                                onChange={(e) => {
                                    let value = e.target.value
                                    if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                                        setAutoRef((prev) => ({ ...prev, autoRefComments: value }))
                                    }
                                }}
                                placeholder='Comments'
                                inputProps={{ maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
                            />
                        </Box>
                    </Box>
                </Box>
                {renderAftComparePopup()}
                {renderBfrComparePopup()}
                {message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
                {message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            </Box>
        </ShowComponents>
    )
})

export default UmaAutoRefractory